<template>
	<div class="d-flex flex-column min-vh-100">
		<div class="py-3 px-5 fs-5 fw-800 bg-white- text-primary-">
			SuitOps
		</div>
		<hr class="m-0" />

		<div class="py-4 flex-grow-1">
			<div class="container h-100">
				<div class="row h-100">
					<div class="my-auto">
						<div class="row">
							<div class="col-md-6 text-center">
								<img src="@/assets/img/logoDeskCol.png" alt="" />
								<h4 class="text-center fw-600 text-three- mt-4">
									{{ $t('auth.login_happy') }}
								</h4>
								<h2 class="text-primary- text-center text-uppercase fs-3 mt-4">
									{{ $t('auth.login_manage') }} <br />
								</h2>
							</div>
							<div class="col-md-6">
								<div class="col-lg-8 rounded bg-primary-light- mx-auto border-black- shadow">
									<div class="px-3 py-3 borderb-black-">
										<div class="hstack">
											<div class="vstack">
												<h4 class="fw-1000 text-2 mb-1 text-primary-" v-if="step === 1">
													{{ $t('auth.new_signup') }}
												</h4>
												<h4 class="fw-1000 text-2 mb-1 text-primary-" v-if="step === 2 || step === 3">
													{{ $t('auth.almost_there') }}
												</h4>
												<p class="text-6 my-0" v-if="step === 1">
													{{ $t('auth.we_need_you') }}
												</p>
												<p class="text-6 my-0" v-if="step === 2">
													{{ $t('auth.valid_email') }}
												</p>
												<p class="text-6 my-0" v-if="step === 3">
													{{ $t('auth.email_is_verify') }}
												</p>
											</div>
											<i v-if="step === 1" class="uil uil-arrow-left ms-auto fs-5 mb-3 text-black" type="button"
												@click="$router.push('/login')"></i>
											<i v-if="step !== 1" class="uil uil-times-circle ms-auto fs-5 mb-3 text-black" type="button"
												@click="$router.go(-1)"></i>
										</div>
									</div>

									<div v-if="globalMessage"
										:class="['alert position-fixed start-0 bottom-0 m-3', globalMessageType === 'success' ? 'alert-success' : 'alert-danger']"
										style="z-index: 1050; min-width: 300px;">
										{{ globalMessage }}
									</div>

									<form @submit.prevent="register1" class="py-2 px-4" v-show="step === 1">
										<InputMe :type="'email'" v-model.trim="emailAddress" :error="errors.emailAddress"
											:placeholder="$t('global.email')" class="mt-4" />
										<SpinnerMe :elementId="'spinner1'" />
										<input type="submit" :value="$t('auth.verify_email')" id="submit1" class="button mt-4 w-100" />
									</form>

									<form @submit.prevent="register2" class="py-3 px-4" v-show="step === 2">
										<p class="text-center fw-600 text-5 text-three- mt-2">
											{{ message }}
										</p>
										<InputMe v-model.trim="code" :error="errors.code" :placeholder="$t('auth.verification_code')" />
										<SpinnerMe :elementId="'spinner2'" />
										<input type="submit" :value="$t('auth.verify_code')" id="submit2" class="button mt-4 w-100" />
									</form>

									<form @submit.prevent="register3" class="py-2 px-4" v-show="step === 3">
										<InputMe v-model.trim="emailAddress" :disabled="true" :error="errors.emailAddress"
											:placeholder="$t('global.email')" :suffixIcon="'uil uil-check text-success text-1'" />
										<InputMe class="mt-4" v-model.trim="companyName" :error="errors.companyName"
											:placeholder="$t('auth.social_reason')" />
										<InputMe class="mt-4" :type="'tel'" v-model.trim="phoneNumber" :error="errors.phoneNumber"
											:placeholder="$t('global.phone')" />
										<InputMe :type="'toggle-password'" v-model.trim="password" :error="errors.password"
											:placeholder="$t('auth.pwd')" class="mt-4" />
										<SpinnerMe :elementId="'spinner3'" />
										<input type="submit" :value="$t('auth.signup')" id="submit3" class="button mt-4 w-100" />
									</form>

									<div class="p-3 text-center text-6 bordert-black-">
										{{ $t('auth.when_connect') }}
										<a :href="SITE_URL + 'legal'" target="_blank" class="red">{{ $t('auth.politicy') }}</a>,
										{{ $t('auth.our') }}
										<a :href="SITE_URL + 'terms'" target="_blank" class="red">{{ $t('auth.conditions') }}</a>
										{{ $t('auth.and_our') }}
										<a :href="SITE_URL + 'privacy'" target="_blank" class="red">{{ $t('auth.confidenciality') }}</a>.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Footer />
	</div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Helper from '@/helpers/helper';
import InputMe from '@/components/InputMe.vue';
import SpinnerMe from '@/components/SpinnerMe.vue';

export default {
	name: 'RegisterPage',
	components: { Footer, InputMe, SpinnerMe },
	data() {
		return {
			companyName: '',
			emailAddress: '',
			phoneNumber: '',
			password: '',
			code: '',
			errors: {}, 
			step: 1,
			message: '',
			globalMessage: '', 
			globalMessageType: '', 
			SITE_URL: '',
		};
	},
	methods: {
		// Fonction pour afficher un message global
		displayGlobalMessage(type, msg) {
			this.globalMessageType = type;
			this.globalMessage = msg;
			setTimeout(() => {
			  this.globalMessage = '';
			  this.globalMessageType = '';
			}, 5000);
		},

		async register1() {
			this.errors = {}; // Réinitialiser les erreurs de champ
			this.globalMessage = ''; // Réinitialiser le message global
			this.globalMessageType = '';

			if (Helper.required(this.emailAddress) === '') {
				delete this.errors.emailAddress;
			} else {
				this.errors.emailAddress = Helper.required(this.emailAddress);
			}

			if (Object.keys(this.errors).length === 0) {
				Helper.loading('submit1', 'spinner1', true);
				let registerFormData = new FormData();
				registerFormData.append('emailAddress', this.emailAddress);

				try {
					const response = await fetch(
						Helper.route('auth/signup/step-1'),
						Helper.requestOptions('POST', registerFormData)
					);
					const data = await response.json();

					Helper.loading('submit1', 'spinner1', false);

					if (data.problems) {
						this.errors = data.problems; // Assigner directement les problèmes aux champs
						this.displayGlobalMessage('error', this.$t('auth.signup.step_1.errors.general')); // Message d'erreur générique
					} else if (data.status) {
						this.message = data.message; // Message spécifique pour l'étape 2
						this.step = 2;
						this.displayGlobalMessage('success', data.message); // Message de succès
					} else {
						this.displayGlobalMessage('error', data.message || this.$t('errors.unexpected'));
					}
				} catch (error) {
					console.error(error);
					Helper.loading('submit1', 'spinner1', false);
					this.displayGlobalMessage('error', this.$t('errors.unexpected'));
				}
			}
		},
		async register2() {
			this.errors = {}; // Réinitialiser les erreurs de champ
			this.globalMessage = ''; // Réinitialiser le message global
			this.globalMessageType = '';

			if (Helper.required(this.code) === '') {
				if (this.code.length === 6) {
					delete this.errors.code;
				} else {
					this.errors.code = 'Le code doit être de 6 chiffres'; // Texte en dur pour l'instant
				}
			} else {
				this.errors.code = Helper.required(this.code);
			}

			if (Object.keys(this.errors).length === 0) {
				Helper.loading('submit2', 'spinner2', true);
				let registerFormData = new FormData();
				registerFormData.append('code', this.code);
				registerFormData.append('emailAddress', this.emailAddress);

				try {
					const response = await fetch(
						Helper.route('auth/signup/step-2'),
						Helper.requestOptions('POST', registerFormData)
					);
					const data = await response.json();

					Helper.loading('submit2', 'spinner2', false);

					if (data.problems) {
						this.errors = data.problems;
						this.displayGlobalMessage('error', this.$t('auth.signup.step_2.errors.general'));
					} else if (data.status) {
						this.step = 3;
						this.displayGlobalMessage('success', data.message);
					} else {
						this.displayGlobalMessage('error', data.message || this.$t('errors.unexpected'));
					}
				} catch (error) {
					console.error(error);
					Helper.loading('submit2', 'spinner2', false);
					this.displayGlobalMessage('error', this.$t('errors.unexpected'));
				}
			}
		},
		async register3() {
			this.errors = {}; // Réinitialiser les erreurs de champ
			this.globalMessage = ''; // Réinitialiser le message global
			this.globalMessageType = '';

			if (Helper.required(this.companyName) === '') {
				delete this.errors.companyName;
			} else {
				this.errors.companyName = Helper.required(this.companyName);
			}
			if (Helper.required(this.phoneNumber) === '') {
				delete this.errors.phoneNumber;
			} else {
				this.errors.phoneNumber = Helper.required(this.phoneNumber);
			}
			if (Helper.required(this.password) === '') {
				delete this.errors.password;
			} else {
				this.errors.password = Helper.required(this.password);
			}
			if (Helper.checkPassword(this.password) !== '') {
				this.errors.password = Helper.checkPassword(this.password);
			}

			if (Object.keys(this.errors).length === 0) {
				Helper.loading('submit3', 'spinner3', true);
				let registerFormData = new FormData();
				registerFormData.append('companyName', this.companyName);
				registerFormData.append('password', this.password);
				registerFormData.append('phoneNumber', this.phoneNumber);
				registerFormData.append('emailAddress', this.emailAddress);

				try {
					const response = await fetch(
						Helper.route('auth/signup/step-3'),
						Helper.requestOptions('POST', registerFormData)
					);
					const data = await response.json();

					Helper.loading('submit3', 'spinner3', false);

					if (data.problems) {
						this.errors = data.problems;
						this.displayGlobalMessage('error', this.$t('auth.signup.step_3.errors.general'));
					} else if (data.status) {
						this.displayGlobalMessage('success', data.message); // Message de succès final
						// Rediriger après un court délai pour que l'utilisateur voie le message
						setTimeout(() => {
							Helper.redirect(Helper.route('login', null, false));
						}, 1500); // Redirection après 1.5 seconde
					} else {
						this.displayGlobalMessage('error', data.message || this.$t('errors.unexpected'));
					}
				} catch (error) {
					console.error(error);
					Helper.loading('submit3', 'spinner3', false);
					this.displayGlobalMessage('error', this.$t('errors.unexpected'));
				}
			}
		},
	},
	watch: {
		emailAddress: function () {
			if (Helper.required(this.emailAddress) === '') {
				delete this.errors.emailAddress;
			} else {
				this.errors.emailAddress = Helper.required(this.emailAddress);
			}
		},
		code: function () {
			if (Helper.required(this.code) === '') {
				if (this.code.length === 6) {
					delete this.errors.code;
				} else {
					this.errors.code = 'Le code doit être de 6 chiffres'; // Texte en dur pour l'instant
				}
			} else {
				this.errors.code = Helper.required(this.code);
			}
		},
		companyName: function () {
			if (Helper.required(this.companyName) === '') {
				delete this.errors.companyName;
			} else {
				this.errors.companyName = Helper.required(this.companyName);
			}
		},
		phoneNumber: function () {
			if (Helper.required(this.phoneNumber) === '') {
				delete this.errors.phoneNumber;
			} else {
				this.errors.phoneNumber = Helper.required(this.phoneNumber);
			}
		},
		password: function () {
			if (Helper.required(this.password) === '') {
				delete this.errors.password;
			} else {
				this.errors.password = Helper.required(this.password);
			}
			if (Helper.checkPassword(this.password) !== '') {
				this.errors.password = Helper.checkPassword(this.password);
			}
		},
	},
	created() {
		this.SITE_URL = Helper.SITE_URL;
	},
};
</script>